module.exports = __webpack_public_path__ + "img/background.125a74fd.jpg";